import React, { useState } from 'react';

import {Button, Modal, Questionnaire} from '../index';
import {getQuestionnaireId, isQuestionnaire, LinkField, urlFor} from '../../lib/Link';
import { useFormModal } from '../../hooks/useFormModal';

import styles from './styles.module.scss';
import ContactForm from "../forms/ContactForm";

interface Props {
  cta: HeroCtaFragment;
  theme?: string;
  name: string;
}

const HeroCTA = ({ cta, theme, name }: Props) => {
  const linkField = cta?.linkField?.[0] as LinkField;
  const linkToSalesForm = cta?.linkToSalesForm;
  const iconUrl = cta.icon?.[0]?.url;
  const { isOpen: enquireModal, openModal, closeModal } = useFormModal(['enquireForm', 'contactForm']);
  const [questionnaireFormOpen, setQuestionnaireForm] = useState(false);

  const toggleQuestionnaireForm = (nextValue = !questionnaireFormOpen) => {
    setQuestionnaireForm(nextValue);
  };


  if (linkField) {
    if (linkToSalesForm) {
        return (
            <>
                <Button onClick={openModal} className={styles[cta?.backgroundColourHero || 'backgroundOrange']}>
                    <div className={styles.icon}>{iconUrl && <img loading="lazy" src={iconUrl} alt={cta.customTitle!} />}</div>
                    <p data-text={cta.customTitle}>
                        {cta.customTitle}
                    </p>
                </Button>
                <Modal isOpen={enquireModal} onRequestClose={closeModal} title={name}>
                    <ContactForm section={'Sales Form'} title={name}/>
                </Modal>
            </>
        );
    }

    if (isQuestionnaire(linkField)) {
      return (
        <>
          <button data-temp={theme} onClick={() => toggleQuestionnaireForm(true)} className={styles[cta?.backgroundColourHero || 'backgroundOrange']}>
            <div className={styles.icon}>{iconUrl && <img loading="lazy" src={iconUrl} alt={cta.customTitle!} />}</div>
            <p data-text={cta.customTitle}>{cta.customTitle}</p>
          </button>
          <Questionnaire
            questionId={getQuestionnaireId(linkField)}
            isOpen={questionnaireFormOpen}
            onClose={() => toggleQuestionnaireForm(false)}
            initValue={cta.customTitle!}
          />
        </>
      );
    }

    return (
      <a href={urlFor(linkField)} className={styles[cta?.backgroundColourHero || 'backgroundOrange']}>
        <div className={styles.icon}>{iconUrl && <img loading="lazy" src={iconUrl} alt={cta.customTitle!} />}</div>
        <p data-text={cta.customTitle}>{cta.customTitle}</p>
      </a>
    );
  }

  return null;
};

export default HeroCTA;
